import { FormField, InputField } from "common";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { MessageTemplate } from "types";
import { removeNonBreakingSpaces } from "../../../helpers/validationHelper";
import { htmlToDisabledHtml, RichEditor } from "../RichEditor/RichEditor";
import { FormState } from "./MessageModalTypes";

interface EmailFormProps {
    template: MessageTemplate | null;
    editTemplate?: boolean;
    showSubject?: boolean;
}

const EmailForm = ({ template, editTemplate, showSubject = true }: EmailFormProps) => {
    const { setFieldValue } = useFormikContext<FormState>();

    const [renderEditor, setRenderEditor] = useState<boolean>(false);

    useEffect(() => setRenderEditor(true), []);

    return (
        <div className="space-y-3">
            {showSubject && (
                <FormField label="Subject" name="email.subject">
                    <InputField
                        isRequired={!template || !!template?.email}
                        placeholder="Subject"
                        disabled={!!template?.email?.subject && !editTemplate}
                    />
                </FormField>
            )}

            <FormField label="Body" name="email.body">
                {template?.email?.body && !editTemplate ? (
                    <div
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: htmlToDisabledHtml(removeNonBreakingSpaces(template?.email?.body) ?? ""),
                        }}
                        // TODO: See HtmlMessageTemplate try dompurify
                        className="no-translate rounded border border-gray-light bg-gray-lighter py-2.5 px-3 text-gray hover:border-black"
                    />
                ) : (
                    renderEditor && (
                        <RichEditor
                            initialContent={template?.email?.body ?? ""}
                            onChange={(html) => {
                                setFieldValue("email.body", html);
                            }}
                        />
                    )
                )}
            </FormField>
        </div>
    );
};

export default EmailForm;
